// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.successContainer.';

const MANAGE_INSTALLMENTS_DESCRIPTION_01 = `${DOMAIN}manageInstallmentsDescription01`,
  MANAGE_INSTALLMENTS_DESCRIPTION_02 = `${DOMAIN}manageInstallmentsDescription02`,
  MANAGE_INSTALLMENTS_DESCRIPTION_03 = `${DOMAIN}manageInstallmentsDescription03`;

export {
  MANAGE_INSTALLMENTS_DESCRIPTION_01,
  MANAGE_INSTALLMENTS_DESCRIPTION_02,
  MANAGE_INSTALLMENTS_DESCRIPTION_03,
};
